import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { LoaderService } from 'src/app/core/services/loader/loader.service';
import { EgiftCardsFacadeService } from 'src/app/modules/e-gift-cards/services/e-gift-cards-facade.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-print-catalog',
  templateUrl: './print-catalog.component.html',
  styleUrls: ['./print-catalog.component.scss']
})
export class PrintCatalogComponent implements OnInit {

  productList: any;
  public cardTypes = environment.card_types;
  suggestionCards = [];
  showingRangeProducts = [];
  priceListId: number;


  constructor(
    private eGiftCardsService: EgiftCardsFacadeService,
    private loaderService: LoaderService,
    private route: ActivatedRoute
  ) { }

  ngOnInit(
  ): void {
    this.route.params.subscribe(params => {
      this.priceListId = +params['id'];
      if (this.priceListId) {
        this.getFullProductList();
      }
    });
  }

  getFullProductList() {
    this.loaderService.show();
    this.eGiftCardsService
      .getPriceListProducts(this.priceListId, 0)
      .subscribe((data) => {
        this.loaderService.hide();
        this.productList = data;
      }, error => {
        this.loaderService.hide();
        console.error('Error loading product list:', error);
      });
  }

  getProductDescription(product) {
    let description = '';
    try {
      description = JSON.parse(product.description).content;
      let temp = ''
      for (let desc of description) {
        temp += `<h4><b>${desc['title']}</b></h4><div>${desc['description']}</div>`
      }

      description = temp;

    } catch {
      description = product.description
    }
    return description;
  }
}